/**
 * @description Browser
 */
export enum Browser {
	CHROME = 'CHROME',
	EDGE = 'EDGE',
	FIREFOX = 'FIREFOX',
	IE = 'IE',
	OPERA = 'OPERA',
	SAFARI = 'SAFARI'
}